var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"easyscreen-volume-control"},[_c('i',{class:[
      'easyscreen-volume-control--icon',
      'fal',
      _vm.icon
    ],on:{"click":_vm.toggleMute}}),_c('easyscreen-progress-bar',{ref:"dndContainer",staticClass:"easyscreen-volume-control--progress",attrs:{"end-marker":"circle","from":0,"to":100,"progress":_vm.muted ? 0 : _vm.volume}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }